import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: { main: '#000722' },
    secondary: { main: '#E0E0E0' },
    error: { main: '#F44336' }
  }
});